import React, { useState, useEffect } from "react";
import "../../../../styles/app.css";

function Foot({setNameForm, onFormSubmit, onSelectionChange}) { 
  const [formState, setFormState] = useState({

    side: "",
    Skin: "pas de plaie, pas de cicatrice",
    Scar: "",

    RearfootAxis:"",
    SingleHeelRiseTest:"",
    ColemanTest:"",

    SubTalarMob:"",
    AnkleAnteriorDrawer:"",
    TalarTilt:"",
    ChopartMobility:"",

    Plantar_Arch:"",
    Midfoot_Axis:"",
    TMT_Pain:"",
    Hyperlaxity_TMT1:"",

    FirstRay:"",
    LateralRays:"",
    F_E_MTP1:"",
    F_E_MTP2_5:"",
    IP_O1:"",
    IP_O2_O5:""


  });

    const [Rearfoot, setRearfoot] = useState(false);
  
    const handleChangeRearfoot = (event) => {
      setRearfoot(event.target.checked);
    }

    const [Midfoot, setMidfoot] = useState(false);
  
    const handleChangeMidfoot = (event) => {
      setMidfoot(event.target.checked);
    }

    const [Forefoot, setForefoot] = useState(false);
  
    const handleChangeForefoot = (event) => {
      setForefoot(event.target.checked);
    }




  useEffect(() => {
    // Run this when the component mounts
    onSelectionChange(true);

    // Run this when the component unmounts
    return () => {
      onSelectionChange(false);
    };
  }, []);





  const [TNVbasic, setTNVbasic] = useState({
    "absence de trouble neuro-vasculaire": false,
  });


  const handleCheckboxChangeTNVbasic = (event) => {
    const { name, checked } = event.target;
     
      setTNVbasic(prev => ({
        ...prev,
        [name]: checked,
     
      }));
    
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    setNameForm("Examen clinique pied");
 // Function to convert the state of the checkboxes into a readable string
    const formatCheckboxStateToString = (checkboxState) => {
      const selectedOptions = Object.entries(checkboxState)
          .filter(([_, isChecked]) => isChecked)
          .map(([key, _]) => key) // Get only the keys (option names)
          .join(", ");

      return selectedOptions || ""; // If no options are selected, return "None selected"
  };

  const TNVbasicText= formatCheckboxStateToString(TNVbasic);


    // Prepare form details for summary
    const formDetails = {
      "Examen clinique pied": formState.side,
      "Etat cutané": [ formState.ankleSkin, formState.ankleScar]
      .filter(val => val !== "" && val !== null && val !== undefined)
      .join(', '),
      "Status neuro-vasculaire": TNVbasicText,
      "Arrière-pied": Rearfoot ? [formState.RearfootAxis, formState.SingleHeelRiseTest, formState.ColemanTest, formState.SubTalarMob, formState.AnkleAnteriorDrawer, formState.TalarTilt, formState.ChopartMobility].filter(function(val) {
        return val;
      }).join('; ') : "sans particularité",
      "Médio-pied": Midfoot ? [formState.Plantar_Arch, formState.Midfoot_Axis, formState.TMT_Pain, formState.Hyperlaxity_TMT1].filter(function(val) {
        return val;
      }).join('; ') : "sans particularité",
      "Avant-pied": Forefoot ? [formState.FirstRay, formState.LateralRays, formState.F_E_MTP1, formState.F_E_MTP2_5, formState.IP_O1, formState.IP_O2_O5].filter(function(val) {
        return val;
      }).join('; ')  : "sans particularité",




  
    };

    const filteredFormDetails = Object.entries(formDetails) // Convert the object to an array of key-value pairs
    .filter(([key, value]) => value !== "")               // Filter out pairs where the value is an empty string
    .reduce((obj, [key, value]) => {                      // Reduce the array back to an object
      obj[key] = value;                                   // Add each key-value pair to the object
      return obj;                                         // Return the object for the next iteration
    }, {});                                               // Start with an empty object

    onFormSubmit(filteredFormDetails); // Call the function passed from App.js and pass the details


   
}

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };




  return (
    <div className="card">
      <p className="title">Examen clinique pied</p>
      <form className="specific-form" onSubmit={handleSubmit}>
      <div>
          <label>Côté:  </label>
          <input type="radio" name="side" value="gauche" checked={formState.side === "gauche"} onChange={handleInputChange} />
            <label> gauche </label>
         
            <input type="radio" name="side" value="droit" checked={formState.side === "droit"} onChange={handleInputChange} />
            <label> droit </label>
        </div>

        <div> 

        <label>Etat cutané:</label>
          <select name="Skin" className="select-input" value={formState.Skin} onChange={handleInputChange} >
            <option value="pas de plaie, pas de cicatrice">Pas de plaie, pas de cicatrice</option>
            <option value="cicatrices d'abord latéral">Cicactrice d'abord latéral</option>
            <option value="cicatrice d'abord médial">cicatrice d'abord médial</option>
            <option value="cicatrice d'abord antérieur">cicatrice d'abord antérieur</option>
            <option value="AUTRE">AUTRE</option>
          </select>

        </div>

        {formState.Skin !== "pas de plaie, pas de cicatrice" && (
           <div>
             <select name="Scar" className="select-input" value={formState.Scar} onChange={handleInputChange} >
             <option value="">Description cicatrice</option>
            <option value="calme, sans signe infectieux">calme, sans signe infectieux</option>
            <option value="inflammatoire">inflammatoire</option>
            <option value="avec signes infectieux (écoulement, rougeur)">signes infectieux (écoulement, rougeur)</option>
            <option value="chéloïde">chéloïde</option>
            <option value="AUTRE">AUTRE</option>
          </select>
         
         </div>
      )
    }



        <div className="checkbox-options">
                
                <input type="checkbox" name="absence de trouble neuro-vasculaire"  onChange={handleCheckboxChangeTNVbasic} />
                <label>absence de trouble neuro-vasculaire</label>
              
          </div>



          <div>

<div>

<input
 type="checkbox"
 name="Rearfoot"
 onChange={handleChangeRearfoot}
 
/>
<label>Arrière pied</label>
{Rearfoot && (
  <>
  <div>

  
  <select className="select-input" name="RearfootAxis" value={formState.RearfootAxis} onChange={handleInputChange} >
    <option value="">Axe arrière pied:</option>
    <option value="axe arrière-pied en varus">varus</option>
    <option value="axe arrière-pied en valgus">valgus</option>

  </select>

  <select className="select-input" name="SingleHeelRiseTest" value={formState.SingleHeelRiseTest} onChange={handleInputChange} >
    <option value="">Single Heel Rise Test:</option>
    <option value="Single Heel Rise test positif">positif</option>
    <option value="Single Heel Rise test négatif">négatif</option>

  </select>

  <select className="select-input" name="ColemanTest" value={formState.ColemanTest} onChange={handleInputChange} >
    <option value="">Test de Coleman:</option>
    <option value="Test de Coleman positif">positif</option>
    <option value="Test de Coleman négatif">négatif</option>

  </select>
  <select className="select-input" name="SubTalarMob" value={formState.SubTalarMob} onChange={handleInputChange} >
    <option value="">Sous-talienne:</option>
    <option value="Sous-talienne souple">souple</option>
    <option value="Sous-talienne enraidie">enraidie</option>
    <option value="Sous-talienne AUTRE">AUTRE</option>

  </select>

  <select className="select-input" name="AnkleAnteriorDrawer" value={formState.AnkleAnteriorDrawer} onChange={handleInputChange} >
    <option value="">Tiroir antérieur:</option>
    <option value="Tiroir antérieur physiologique">physiologique</option>
    <option value="Tiroir antérieur augmenté par rapport au controlatéral">augmenté par rapport au controlatéral</option>
    <option value="Tiroir antérieur AUTRE">AUTRE</option>
  </select>

  <select className="select-input" name="TalarTilt" value={formState.TalarTilt} onChange={handleInputChange} >
    <option value="">Talar Tilt:</option>
    <option value="Talar Tilt physiologique">physiologique</option>
    <option value="Talar Tilt augmenté par rapport au controlatéral">augmenté par rapport au controlatéral</option>
    <option value="Talar Tilt AUTRE">AUTRE</option>
  </select>

  <select className="select-input" name="ChopartMobility" value={formState.ChopartMobility} onChange={handleInputChange} >
    <option value="">Mobilité Chopart:</option>
    <option value="Mobilisation Chopart indolore">indolore</option>
    <option value="Mobilisation Chopart douloureuse">douloureuse</option>
    <option value="Chopart AUTRE">AUTRE</option>
  </select>

 
  </div>
  </>
)}
</div>

<div>
<input
 type="checkbox"
 name="Midfoot"
 onChange={handleChangeMidfoot}
 
/>

<label>Médio-pied</label>
{Midfoot && (
  <>
  <div>

  <select className="select-input" name="Plantar_Arch" value={formState.Plantar_Arch} onChange={handleInputChange} >
    <option value="">Arche plantaire:</option>
    <option value="Arche plantaire physiologique">Physiologique</option>
    <option value="Arche plantaire creuse">Creuse</option>
    <option value="Arche plantaire affaissée">Affaissée</option>

  </select>

  <select className="select-input" name="Midfoot_Axis" value={formState.Midfoot_Axis} onChange={handleInputChange} >
    <option value="">Axe médio-pied:</option>
    <option value="Axe médio-pied physiologique">Physiologique</option>
    <option value="Axe médio-pied en abductus">Abductus</option>
    <option value="Axe médio-pied en adductus">Adductus</option>

  </select>

  <select className="select-input" name="TMT_Pain" value={formState.TMT_Pain} onChange={handleInputChange} >
    <option value="">interligne Lisefranc:</option>
    <option value="Interligne Lisefranc indolore">indolore</option>
    <option value="interligne Lisefranc douloureux, PRECISION NIVEAU">Douloureux, niveau à préciser en texte libre</option>


  </select>


  <select className="select-input" name="Hyperlaxity_TMT1" value={formState.Hyperlaxity_TMT1} onChange={handleInputChange} >
    <option value="">Articulation TMT1:</option>
    <option value="mobilité articulation TMT1 physiologique">mobilité physiologique</option>
    <option value="Hyperlaxité articulation TMT1">Hyperlaxité</option>


  </select>
  


  </div>
  </>

)}

</div>

<div>


<input
 type="checkbox"
 name="Frontfoot"
 onChange={handleChangeForefoot}
 
/>

<label>Avant pied</label>
{Forefoot && (
  <>
  <div>

  <select className="select-input" name="FirstRay" value={formState.FirstRay} onChange={handleInputChange} >
    <option value="">Axe 1er rayon:</option>
    <option value="Axe 1er rayon physiologique"> Physiologique</option>
    <option value="Axe 1er rayon varus">Varus</option>
    <option value="Axe 1er rayon valgus">Valgus</option>
  </select>

  <select className="select-input" name="LateralRays" value={formState.LateralRays} onChange={handleInputChange} >
    <option value="">Axe rayons latéraux:</option>
    <option value="Axe rayons latéraux physiologique">Physiologique</option>
    <option value="Déformation axe rayons latéraux: PRECISION">Déformation, précision en texte libre</option>
  </select>

  <select className="select-input" name="F_E_MTP1" value={formState.F_E_MTP1} onChange={handleInputChange} >
    <option value="">Flexion/Extension MTP1:</option>
    <option value="F/E MTP1 physiologique">Physiologique</option>
    <option value="MTP1 enraidie">Enraidie</option>
  </select>

  <select className="select-input" name="F_E_MTP2_5" value={formState.F_E_MTP2_5} onChange={handleInputChange} >
    <option value="">Flexion/Extension MTP 2-5:</option>
    <option value="F/E MTP 2-5 physiologique">Physiologique</option>
    <option value="MTP 2-5 enraidis">Enraidies</option>
  </select>

  <select className="select-input" name="IP_O1" value={formState.IP_O1} onChange={handleInputChange} >
    <option value="">Flexion/Extension IP1:</option>
    <option value="F/E IP1 physiologique">Physiologique</option>
    <option value="IP1 enraidie">Enraidie</option>
  </select>

  <select className="select-input" name="IP_O2_O5" value={formState.IP_O2_O5} onChange={handleInputChange} >
    <option value="">Flexion/Extension orteils 2-5:</option>
    <option value="F/E O2-5 physiologique">Physiologique</option>
    <option value="O2-5 enraidis">Enraidie</option>
  </select>


  </div>
  </>

)}
</div>
</div>


        <button type="submit" className="button send">Send</button>
      </form>
    </div>
  );
}

export default Foot;